import i18n from "@/i18n";
import Vue from "vue";
import axios from "axios";
import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,
  state: {
    fetched: false,
    shops: [],
    savingInProgress: false,
    public_api_key: null
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    async get({ commit, state, dispatch }) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(`${this._vm.$apiURL}/shops`)
        .then((response) => {
          updateField(state, { path: "shops", value: response.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .post(this._vm.$apiURL + "/shops", payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          if (response.data && response.data.status === "success") {
            return true;
          } else {
            dispatch(
              "common/showError",
              { error: response.data.error },
              { root: true }
            );
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async update({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });



      updateField(state, {path:'savingInProgress', value:true});
      let formData = new FormData();
      formData.append("_method", "PUT");
      for ( let key in payload ) {
        if(key !=='logoFile' ) {
          if(payload[key]!==null) {
            formData.append(key, payload[key]);
          }
        } else {
          formData.append(key, payload[key].file);
        }
      }
      return axios.post(this._vm.$apiURL + "/shops/" + payload.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }}
      )
        .then((response) => {
          if (response.data && response.data.status === "success") {
            this._vm.$inform(this._vm.i18n.t("common.operation_success"));
            return true;
          } else {
            dispatch(
              "common/showError",
              { error: response.data.error },
              { root: true }
            );
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async getPublicApiKey({ commit, state, dispatch }, payload){
      updateField(state, { path: "public_api_key", value: null });
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(`${this._vm.$apiURL}/shops/public-api-key`)
        .then((response) => {
          if(response.data && response.data.public_api_key) {
            updateField(state, {path: "public_api_key", value: response.data.public_api_key});
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async generatePublicApiKey({ commit, state, dispatch }, payload){
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .put(`${this._vm.$apiURL}/shops/public-api-key`)
        .then((response) => {
          if(response.data && response.data.public_api_key) {
            updateField(state, {path: "public_api_key", value: response.data.public_api_key});
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async updateWorkingHours({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
          .put(this._vm.$apiURL + `/shops/${payload.shop_id}/working-hours`, payload)
          .then((response) => {
            this._vm.$inform(this._vm.i18n.t('common.operation_success'));
            if (response.data && response.data.status === "success") {
              return response.data.data;
            } else {
              dispatch(
                  "common/showError",
                  { error: response.data.error },
                  { root: true }
              );
            }
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "savingInProgress", value: false });
          });
    },
    async toggleIsEnabledAutomaticPayments({ commit, state, dispatch }, payload){
      updateField(state, {path:'savingInProgress', value:true});
      return await  axios.put(this._vm.$apiURL + `/shops/${payload.shop_id}/toggle-enabling-automatic-payments`)
          .then((response) => {
            if(response.data.status === "success") {
              this._vm.$inform(this._vm.i18n.t('common.operation_success'));
              return response.data;
            }
          })
          .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
            return false
          })
          .finally(()=>{
            updateField(state, {path:'savingInProgress', value:false});
          })
    }
  },
};
